import {useDataProvider, useNotify, useQuery, useRefresh} from "react-admin";
import React from "react";
import {Form, InputNumber, Select, Switch} from "antd";
import {createSubmitHandler} from "@src/components/Settings/utils";
import {ExtendedDataProvider} from "@src/types";


const GUITableSettingsForm = () => {
    const notify = useNotify ()
    const [form] = Form.useForm ();
    const refresh = useRefresh();
    const dataProvider: ExtendedDataProvider = useDataProvider ()
    const settingsName = "GUITableSettings"

    const {loaded, error, data: currentSettings} = useQuery ({
        type: 'getOne',
        resource: 'general_settings',
        payload: {id: settingsName}
    });

    const States = ["PENDING", "REJECTED", "APPROVED", "ERROR", "COMPLETED"]

    return (
        <>
            {
                (loaded || error) &&
                <Form
                    form={form}
                    labelAlign='left'
                    labelCol={{ span: 10 }}
                    wrapperCol={{ span: 14 }}
                    onFinish={createSubmitHandler(settingsName, currentSettings, dataProvider, notify, refresh)}
                >
                    <Form.Item valuePropName='checked' label="Table Refresh Enable" name="ENABLED" initialValue={currentSettings?.['config']?.ENABLED || false}>
                        <Switch defaultChecked={currentSettings?.['config']?.ENABLED == true} />
                    </Form.Item >

                    <Form.Item
                        name={"table_refresh_interval"}
                        label={"Table Refresh Interval (in seconds)"}
                        initialValue={currentSettings?.['config']?.table_refresh_interval}
                        rules={[{
                            type: "number",
                            min: 5,
                            message: "Interval must be at least 5 seconds"
                        }]}
                    >
                        <InputNumber style={{ width: "100%" }} />
                    </Form.Item>

                    <Form.Item
                        name="default_filter_states_for_consumers"
                        label="Defult State Filter for Consumers"
                        initialValue={currentSettings?.['config']?.default_filter_states_for_consumers || []}
                        rules={[{ type: "array", min: 1, message: "Please select at least one state" }]}
                    >
                        <Select mode="multiple" style={{ width: "100%" }} placeholder="Select states">
                            {States.map(state => <Select.Option key={state} value={state}>{state}</Select.Option>)}
                        </Select>
                    </Form.Item>

                    <Form.Item
                        name="default_filter_states_for_serviceowners"
                        label="Defult State Filter for Service Owners"
                        initialValue={currentSettings?.['config']?.default_filter_states_for_serviceowners || []}
                        rules={[{ type: "array", min: 1, message: "Please select at least one state" }]}
                    >
                        <Select mode="multiple" style={{ width: "100%" }} placeholder="Select states">
                            {States.map(state => <Select.Option key={state} value={state}>{state}</Select.Option>)}
                        </Select>
                    </Form.Item>


                </Form>
            }
        </>
    )
}

export default GUITableSettingsForm;
